import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=bacb0a6e&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=ts"
export * from "./ProjectItem.vue?vue&type=script&lang=ts"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=bacb0a6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb0a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacb0a6e')) {
      api.createRecord('bacb0a6e', component.options)
    } else {
      api.reload('bacb0a6e', component.options)
    }
    module.hot.accept("./ProjectItem.vue?vue&type=template&id=bacb0a6e&scoped=true", function () {
      api.rerender('bacb0a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/scheduler/ProjectItem.vue"
export default component.exports